export default "https://yastatic.net/s3/frontend/vconf-frontend/_/NoConnectionStub.00609949.svg";